<template>
  <v-container fluid class="loadingorder-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-loadingorder`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Order
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-loading`">
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Loading
          </v-tab>
          <v-tab :href="`#tab-images`" class="mr-5">
            <v-icon class="mr-3">mdi-image-multiple-outline</v-icon>
            Images
          </v-tab>
          <v-tab-item :value="'tab-loadingorder'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Loading Order</p>
                      <v-menu
                        ref="menu_loadingorderdate"
                        v-model="menu_loadingorderdate"
                        :close-on-content-click="false"
                        :return-value.sync="loadingorderdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="loadingorderdate"
                            label="Loading Order Date"
                            v-bind="attrs"
                            v-bind:value="loadingorderdate"
                            v-on:change="
                              onChangedValue($event, 'loadingorderdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the loading order date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="loadingorderdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_loadingorderdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangedValue(
                                loadingorderdate,
                                'loadingorderdate'
                              );
                              $refs.menu_loadingorderdate.save(loadingorderdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-select
                        class="mb-4"
                        :items="loadingordertype"
                        v-model="initvalue.loadingordertype"
                        v-on:change="
                          onChangedValue($event, 'loadingordertype')
                        "
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the loading order type"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="
                          locations.filter(location=>location.locationstatus=='Active').map((x) => {
                            return { text: x.locationname, value: x._id };
                          })
                        "
                        v-model="initvalue.locationid"
                        v-bind:error="errorindex == 2"
                        v-on:change="onChangedValue($event, 'locationid');"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line
                        hint="Please choose the location"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>

                      <v-select
                        class="mb-4"
                        :items="
                          vehicles.map((x) => {
                            return { text: x.vehiclename, value: x._id };
                          })
                        "
                        v-model="initvalue.vehicleid"
                        v-on:change="onChangedValue($event, 'vehicleid')"
                        v-bind:error="errorindex == 3"
                        outlined
                        dense
                        placeholder="Vehicle"
                        persistent-hint
                        single-line
                        hint="Please choose the vehicle"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="
                          users.filter(user=>user.userstatus=='Active').map((x) => {
                            return { text: x.username, value: x._id };
                          })
                        "
                        v-model="initvalue.driverid"
                        v-on:change="onChangedValue($event, 'driverid')"
                        v-bind:error="errorindex == 4"
                        outlined
                        dense
                        placeholder="Driver"
                        persistent-hint
                        single-line
                        hint="Please choose the driver"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="
                          users.filter(user=>user.userstatus=='Active').map((x) => {
                            return { text: x.username, value: x._id };
                          })
                        "
                        v-model="initvalue.loaderid"
                        v-on:change="onChangedValue($event, 'loaderid')"
                        v-bind:error="errorindex == 4"
                        outlined
                        dense
                        placeholder="Loader"
                        persistent-hint
                        single-line
                        hint="Please choose the loader"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        outlined
                        dense
                        class="mb-4"
                        v-model="initvalue.loadingordername"
                        v-on:change="
                          onChangedValue($event, 'loadingordername')
                        "
                        v-bind:error="errorindex == 10"
                        placeholder="Loading Name"
                        persistent-hint
                        single-line
                        hint="Enter the Location Name"
                      >
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="loadingorderstatus"
                        v-model="initvalue.loadingorderstatus"
                        v-on:change="
                          onChangedValue($event, 'loadingorderstatus')
                        "
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        v-model="initvalue.loadingordernote"
                        v-on:change="onChangedValue($event, 'loadingordernote')"
                        v-bind:error="errorindex == 10"
                        outlined
                        dense
                        placeholder="Note"
                        persistent-hint
                        single-line
                        hint="Enter the note"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/loadingorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateLoadingOrder()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-loading'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <p class="text-h5">Items</p>
                    <v-form>
                      <v-row justify="center">
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="
                              brands.filter(x=>x.brandtype=='Brand').map((x) => {
                                return { text: x.brandname, value: x._id };
                              })
                            "
                            v-model="newTransaction.brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line
                            hint="Brand"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="3">
                          <v-select
                            class="mb-4"
                            :items="newTransaction.branditems"
                            v-model="newTransaction.itemid"
                            v-bind:error="errorindex == 0"
                            v-on:change="populateQuantityField"
                            outlined
                            dense
                            placeholder="Item"
                            persistent-hint
                            single-line
                            hint="Item"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="itemquantity0"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateLoading"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Quantity"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="itempieces0"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Pcs"
                            persistent-hint
                            type="number"
                            v-on:input="calculatePieces"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Pieces"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            readonly
                            v-model="itemweight0"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Wgt"
                            persistent-hint
                            single-line
                            hint="Weight"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            readonly
                            v-model="itemvolume0"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Vol"
                            persistent-hint
                            single-line
                            hint="Volume"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="insertLOTransaction()"
                          >
                            Add
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="itemHeaders"
                        :items="transactions"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ deletetransaction.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(deletetransaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemid="{ item }">
                          {{ items.length>0 && item.itemid ? items.find(x=>x._id == item.itemid)['itemname'] : ''  }}
                        </template>
                        <template v-slot:item.itemquantity="{ item }">
                          {{ item.itemquantity.toFixed(3) }}
                        </template>
                        <template v-slot:item.itemweight="{ item }">
                          {{ item.itemweight.toFixed(3) }}
                        </template>
                        <template v-slot:item.itemvolume="{ item }">
                          {{ item.itemvolume.toFixed(3) }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template slot="body.append">
                          <tr v-if="orderquantity!=null && orderweight!=null">
                            <th></th>
                            <th>{{ orderquantity.toFixed(3) }}</th>
                            <th>{{ orderweight.toFixed(3) }}</th>
                            <th>{{ ordervolume.toFixed(3) }}</th>
                            <th></th>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/loadingorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-images'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Images</p>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="isAddImage = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="imageHeaders"
                        :items="images"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteImage" width="500">
                            <v-card>
                              <v-card-title> Delete this Image? </v-card-title>
                              <v-card-text>
                                {{ deleteimage.imagename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteImage = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteImage(deleteimage)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.imagetype="{ item }">
                            <a v-if="item.imagetype=='jpg'" :href="item.imageurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-image-outline
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.imagesize="{ item }">
                            {{ (item.imagesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteImageDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/loadingorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
      <v-row justify="center">
    <v-dialog
      v-model="isAddImage"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Upload Image</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
              <v-file-input label="Image input" v-on:change="onImageChange" accept=".jpg" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="upload_image.imagename"
                  label="Image Name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddImage = false; upload_image.image=null; upload_image.imagename=''"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="upload_image.image==null && this.upload_image.imagename.length<2"
            color="blue darken-1"
            text
            @click="uploadImage"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
      <v-bottom-sheet v-model="isEditTransaction" inset @input="onClose">
        <v-sheet class="text-center" height="220px">
          <v-btn class="mt-6" text color="error" @click="isEditTransaction = false; route=0;">
            close
          </v-btn>
          <v-row justify="center">
            <v-col cols="12" md="4">
              <v-select
                class="mb-4"
                :items="editTransaction.branditems"
                v-model="editTransaction.itemid"
                v-bind:error="errorindex == 0"
                outlined
                dense
                placeholder="Item"
                persistent-hint
                single-line
                hint="Item"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                v-model="itemquantity1"
                class="mb-4"
                outlined
                dense
                placeholder="Qty"
                persistent-hint
                type="number"
                v-on:input="calculateLoading"
                oninput="if(this.value < 0) this.value = 0;"
                single-line
                hint="Quantity"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                v-model="itempieces1"
                class="mb-4"
                outlined
                dense
                placeholder="Pcs"
                persistent-hint
                type="number"
                v-on:input="calculatePieces"
                oninput="if(this.value < 0) this.value = 0;"
                single-line
                hint="Pieces"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                readonly
                v-model="itemweight1"
                class="mb-4"
                outlined
                dense
                placeholder="Wgt"
                persistent-hint
                single-line
                hint="Weight"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                readonly
                v-model="itemvolume1"
                class="mb-4"
                outlined
                dense
                placeholder="Vol"
                persistent-hint
                single-line
                hint="Volume"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-btn
            class="button-shadow"
            color="warning"
            @click="editLOTransaction()"
          >
            Edit
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      etddate: null,
      etadate: null,
      loadingorderdate: null,
      menu_loadingorderdate: false,
      menu_etddate: false,
      menu_etadate: false,
      route: 0,
      deletetransaction: {},
      deleteimage: {},
      loadingorder: {},
      editTransaction: {branditems:[]},
      newTransaction: {branditems:[]},
      trade: {},
      upload_image: {imagename: '', image: null},
      itemHeaders: [
        { text: "Item", value: "itemid" },
        { text: "Quantity", value: "itemquantity", width: "10%" },
        { text: "Weight", value: "itemweight", width: "10%" },
        { text: "Volume", value: "itemvolume", width: "10%" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      imageHeaders: [
        { text: "Type", value: "imagetype" },
        { text: "Name", value: "imagename" },
        { text: "Size", value: "imagesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      images: [],
      transactions: [],
      loadingordertype: ["Loading Order"],
      loadingorderstatus: ["New", "Loaded", "Unloaded"],
      
      isEditTransaction: false,
      isAddImage: false,
      brandid: undefined,
      
      itemid: undefined,
      itemname: undefined,
      
      itemquantity0: undefined,
      itempieces0: undefined,
      itemweight0: undefined,
      itemvolume0: undefined,
      itemquantity1: undefined,
      itempieces1: undefined,
      itemweight1: undefined,
      itemvolume1: undefined,

      orderquantity: undefined,
      orderweight: undefined,
      ordervolume: undefined,

      isDeleteDialog: false,
      isDeleteImage: false,

      initvalue: {},
      imageurl: undefined,

      error: undefined,
      errorindex: undefined,
    };
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("Image", ["insertRouteImage", "deleteImageRequest"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Price", ["getPricesRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    ...mapActions("LoadingOrder", ["deleteLOTransactionRequest", "insertLOTransactionRequest", "updateLoadingOrderRequest", "updateLOTransactionRequest"]),
    ...mapActions("Vehicle", ["getVehiclesRequest"]),
    calculateLoading(){
      let transaction;
      if(this.route==0){
        transaction = this.newTransaction;
        if(transaction.itemid==undefined) {
          this.$nextTick(()=>this.itemquantity0 = null);
          return;
        }
        let item = this.items.find(item=>item._id==transaction.itemid);
        if(item==null) return;
        let w = item.itemweight;
        let v = item.itemvolume;

        if(this.itempieces0!=null) this.itemweight0 = (w * (parseFloat(this.itempieces0/item.itemconvert) + parseFloat(this.itemquantity0))).toFixed(3);
        else this.itemweight0 = ((this.itemquantity0) * w).toFixed(3);

        if(this.itempieces0!=null) this.itemvolume0 = (v * (parseFloat(this.itempieces0/item.itemconvert) + parseFloat(this.itemquantity0))).toFixed(3);
        else this.itemvolume0 = ((this.itemquantity0) * v).toFixed(3);
        this.itemquantity0 = parseInt(this.itemquantity0);
      } 
      if(this.route==1) {
        transaction = this.editTransaction;
        if(transaction.itemid==undefined) {
          this.$nextTick(()=>this.itemquantity1 = null);
          return;
        }
        let item = this.items.find(item=>item._id==transaction.itemid);
        if(item==null) return;
        let w = item.itemweight;
        let v = item.itemvolume;

        if(this.itempieces1!=null) this.itemweight1 = (w * (parseFloat(this.itempieces1/item.itemconvert) + parseFloat(this.itemquantity1))).toFixed(3);
        else this.itemweight1 = ((this.itemquantity1) * w).toFixed(3);

        if(this.itempieces1!=null) this.itemvolume1 = (v * (parseFloat(this.itempieces1/item.itemconvert) + parseFloat(this.itemquantity1))).toFixed(3);
        else this.itemvolume1 = ((this.itemquantity1) * v).toFixed(3);
        this.itemquantity1 = parseInt(this.itemquantity1);
      }
    },
    calculatePieces(input){
      let transaction;
      if(this.route==0){
        transaction = this.newTransaction;
        if(transaction.itemid==undefined) {
          this.$nextTick(()=>this.itempieces = null);
          return;
        }
        let item = this.items.find(item=>item._id==transaction.itemid);
        if(item==null) return;

        this.$nextTick(()=>{
          if(input<item.itemconvert) this.itempieces0 = parseInt(this.itempieces0);
          else if(input==item.itemconvert) this.itempieces0 = item.itemconvert;
          else this.itempieces0 = item.itemconvert;
          console.log("here1", this.itemquantity0, this.itempieces0);
          this.calculateLoading();
        });
      } 
      if(this.route==1){
        transaction = this.editTransaction;
        if(transaction.itemid==undefined) {
          this.$nextTick(()=>this.itempieces = null);
          return;
        }
        let item = this.items.find(item=>item._id==transaction.itemid);
        if(item==null) return;
        this.$nextTick(()=>{
          if(input<item.itemconvert) this.itempieces1 = parseInt(this.itempieces1);
          else if(input==item.itemconvert) this.itempieces1 = item.itemconvert;
          else this.itempieces1 = item.itemconvert;
          this.calculateLoading();
        });
      }       
    },
    calculateTotal() {
      if(this.transactions==null) return;
      this.orderquantity = this.transactions.reduce((a,b) => a + (b.itemquantity), 0);
      this.orderweight = this.transactions.reduce((a,b) => a + (b.itemweight), 0);
      this.ordervolume = this.transactions.reduce((a,b) => a + (b.itemvolume), 0);
    },
    clearTransaction() {
      if(this.route==0) {
        this.newTransaction = {branditems:[]};
        this.itemquantity0 = null;
        this.itempieces0 = null;
        this.itemweight0 = null;
        this.itemvolume0 = null;
      }
      else if(this.route==1) {
        this.editTransaction = {branditems:[]};
        this.itemquantity1 = null;
        this.itempieces1 = null;
        this.itemweight1 = null;
        this.itemvolume1 = null;
      }
    },
    async editLOTransaction() {
      if(this.editTransaction.itemid==null || this.itemquantity1==null) return;
      let transaction = {
        _id: this.editTransaction._id,
        itemid: this.editTransaction.itemid,
        itemquantity: this.itemquantity1,
        itemweight: this.itemweight1,
        itemvolume: this.itemvolume1,
      };
      let item = this.items.find(item=>item._id==transaction.itemid);
      if(item==null) return;
      if(this.itempieces1!=null) transaction.itemquantity = parseFloat(this.itemquantity1) + parseFloat(this.itempieces1 / item.itemconvert);

      let result = await this.updateLOTransactionRequest(transaction);
      let index = this.transactions.findIndex((trans) => trans._id == result._id);
      this.transactions.splice(index, 1, result);
      
      this.isEditTransaction = false;
      this.calculateTotal();
      this.clearTransaction(1);
    },
    editTransactionDialog(trans) {
      this.route = 1;
      this.editTransaction = Object.assign({}, trans);
      
      let item = this.items.find((x) => x._id == trans.itemid);
      let pieces = trans.itemquantity % 1;

      this.itemquantity1 = (trans.itemquantity - pieces).toFixed(0);
      this.itempieces1 = (pieces * item.itemconvert).toFixed(0);
      this.itemweight1 = trans.itemweight;
      this.itemvolume1 = trans.itemvolume;
      this.editTransaction.transid = trans._id;
      this.editTransaction.brandid = item.brandid;
      this.populateItems(this.editTransaction.brandid);
      this.isEditTransaction = true;
    },

    async insertLOTransaction() {
      if(this.newTransaction.itemid==null || this.itemquantity0==null) return;
      let transaction = {
        loadingorderid: this.initvalue._id,
        itemid: this.newTransaction.itemid,
        itemquantity: this.itemquantity0,
        itemweight: this.itemweight0,
        itemvolume: this.itemvolume0,
      };
      let item = this.items.find(item=>item._id==transaction.itemid);
      if(item==null) return;
      if(this.itempieces0!=null) transaction.itemquantity = parseFloat(this.itemquantity0) + parseFloat(this.itempieces0 / item.itemconvert);
      
      let result = await this.insertLOTransactionRequest(transaction);
      this.transactions.push(result);
      this.calculateTotal();
      this.clearTransaction(0);
    },
    async uploadImage(){
      this.upload_image.id = this.initvalue._id;
      this.upload_image.route = 'loadingorder';
      this.isAddImage = false;
      let image = await this.insertRouteImage(this.upload_image);
      this.images.push(image);
    },
    deleteTransactionDialog(trans) {
      let item = this.items.find(item=>item._id==trans.itemid);
      this.isDeleteDialog = true;
      this.deletetransaction = {_id: trans._id, itemname: item.itemname, itemquantity: trans.itemquantity};
    },
    async deleteTransaction(item) {
      this.isDeleteDialog = false;
      let result = await this.deleteLOTransactionRequest(item._id);
      let index = this.transactions.findIndex((trans) => trans._id == result._id);
      this.transactions.splice(index, 1);
      this.calculateTotal();
    },
    deleteImageDialog(item) {
      this.isDeleteImage = true;
      this.deleteimage = {_id: item._id,imagename: item.imagename};
    },
    async deleteImage(item) {
      this.isDeleteImage = false;
      let response = await this.deleteImageRequest(item);
      let index = this.images.findIndex((trans) => trans._id == response._id);
      this.images.splice(index, 1);
    },
    onClose(){
      this.route=0;
    },
    onImageChange(image) {
      if (!image) this.upload_image.image = null;
      else this.upload_image.image = image;
    },
    populateItems(brandid) {
      let items = this.items.filter((item) => item.brandid == brandid);
      if(this.route==0) this.newTransaction.branditems = items.map((x) => {return { text: x.itemname, value: x._id }});
      else if(this.route==1) this.editTransaction.branditems = items.map((x) => {return { text: x.itemname, value: x._id }});
    },
    populateQuantityField(itemid) {
      let item = this.items.find((item) => item._id == itemid);
      if(item==null) return;
      if(this.route==0){
        this.itemquantity0 = 1;
        this.itempieces0 = null;
        this.itemweight0 = item.itemweight;
        this.itemvolume0 = item.itemvolume;
      }
      else if(this.route==1){
        this.itemquantity1 = 1;
        this.itempieces1 = null;
        this.itemweight1 = item.itemweight;
        this.itemvolume1 = item.itemvolume;
      }
    },
    async updateLoadingOrder() {
      this.loadingorder._id = this.initvalue._id;
      await this.updateLoadingOrderRequest(this.loadingorder);
      router.push("/loadingorder/list");
    },

    onChangedValue(value, field) {
      this.loadingorder[field] = value;
    },
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("Location", ["locations"]),
    ...mapState("Item", ["items"]),
    ...mapState("Price", ["prices"]),
    ...mapState("User", ["users"]),
    ...mapState("Vehicle", ["vehicles"]),
    ...mapState("LoadingOrder", ["isReceiving"]),
  },
  async created() {
    this.initvalue = this.$route.params;
    this.transactions = this.initvalue.transactions;
    this.images = this.initvalue.images;
    if (!this.initvalue._id) this.$router.push({ name: "LoadingOrderList" });
    if (this.brands.length==0) await this.getBrandsRequest();
    if (this.items.length==0) await this.getItemsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.users.length==0) await this.getUsersRequest();
    if (this.vehicles.length==0) await this.getVehiclesRequest();

    this.loadingorderdate = formatStdDate(this.initvalue.loadingorderdate);
    
    this.calculateTotal();
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
